<template>
    <div class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
            <header class="modal-header">
                <h2>{{ $t('codeModal.installCodeOnSite') }}</h2>
                <button class="close-button" @click="closeModal" :aria-label="$t('codeModal.close')">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </header>

            <div class="modal-body">
                <p class="code-title">{{ $t('codeModal.widgetCode') }}</p>
                <div class="code-container">
                    <pre><code>{{ codeSnippet }}</code></pre>
                </div>
            </div>

            <footer class="modal-footer">
                <BaseButton
                    variant="primary"
                    @click="copyCodeToClipboard"
                    :customHeight="48"
                    customClass="!ppv2-min-w-[160px] !ppv2-bg-[#7D2DBD] hover:!ppv2-bg-[#6b26a3]"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="ppv2-mr-2"
                    >
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    <span>{{ copyButtonText }}</span>
                </BaseButton>
            </footer>
        </div>
    </div>
</template>

<script>
import BaseButton from './Shared/BaseButton.vue'

export default {
    components: {
        BaseButton,
    },
    props: {
        codeSnippet: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            copyButtonText: this.$t('codeModal.copyCode'),
        }
    },
    methods: {
        closeModal() {
            this.$emit('close')
        },
        async copyCodeToClipboard() {
            try {
                await navigator.clipboard.writeText(this.codeSnippet)
                this.copyButtonText = this.$t('codeModal.copied')
                setTimeout(() => {
                    this.copyButtonText = this.$t('codeModal.copyCode')
                }, 2500)
            } catch (err) {
                console.error('Failed to copy text: ', err)
                this.copyButtonText = this.$t('codeModal.copyError')
            }
        },
    },
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-content {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    width: 90%;
    max-width: 680px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h2 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #192a56;
    margin: 0;
    text-align: center;
}

.close-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #a4b0be;
    padding: 0;
}

.close-button:hover {
    color: #3e4254;
}

.code-title {
    font-weight: 500;
    color: #3e4254;
    margin-bottom: 0.5rem;
}

.code-container {
    border: 1px dotted #a4b0be;
    border-radius: 12px;
    background-color: #f8f9fa;
    padding: 1.5rem;
    max-height: 40vh;
    overflow-y: auto;
}

pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
}

code {
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.875rem;
    color: #333;
}

.modal-footer {
    display: flex;
    justify-content: center;
}

.copy-button {
    background-color: #192a56;
    color: white;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    padding: 0.75rem 2rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.copy-button:hover {
    background-color: #2c3e50;
}
</style>
